import { Button, Pin2FillIcon, PinLineIcon } from 'ui';

type P = {
  onChange?: (active: boolean) => void;
  value?: boolean;
};

export const PinnedPostToggle = ({ onChange, value }: P) => (
  <Button
    data-test-id="toggle_pin-post"
    icon={value ? <Pin2FillIcon /> : <PinLineIcon />}
    onClick={() => {
      onChange?.(!value);
    }}
    type={value ? 'link-primary' : 'link-secondary'}
  >
    {value ? 'Post pinned' : 'Pin post'}
  </Button>
);
